import EventBus from '@/controller/EventBus';

export default function checkIsOverSelectArea(eleRef, callback, mouseDown, _keyType) {
  // 鼠标移动判断是否选中
  EventBus.mouseSelected.addEventLister('mouseSelected', ({ pos, offset, calc, keyType }) => {
    if (_keyType !== keyType) {
      // 不是同一个类型
      return;
    }
    let isSelected = false;
    const ele = eleRef?.getBoundingClientRect();
    if (!ele) return;
    const { endLeftScroll, endTopScroll } = pos;
    const { leftOffset, topOffset } = offset;
    const { left, top, width, height } = calc;
    const posValue = {
      left,
      top,
      bottom: top + Math.abs(height),
      right: left + Math.abs(width),
    };
    const elePos = {
      top: ele.top + endTopScroll - topOffset,
      left: ele.left + endLeftScroll - leftOffset,
    };
    elePos.bottom = elePos.top + ele.height;
    elePos.right = elePos.left + ele.width;
    if (
      !(
        posValue.right < elePos.left ||
        posValue.left > elePos.right ||
        posValue.bottom < elePos.top ||
        posValue.top > elePos.bottom
      )
    ) {
      isSelected = true;
    }
    if (callback) {
      callback(isSelected);
    }
  });
  EventBus.mouseSelected.addEventLister('mouseDown', ({ keyType }) => {
    if (_keyType !== keyType) {
      // 不是同一个类型
      return;
    }
    if (mouseDown) {
      mouseDown();
    }
  });
}
